// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__MT7Xf","bigColWidth":"Table_bigColWidth__3PfIR","biggerColWidth":"Table_biggerColWidth__3xIqm","row":"Table_row__3fS9z","col":"Table_col__3xjLx"};